import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import {EntityType} from "../../../../../../gd/const/item"

// const debug = "FieldAttachmentsTotal_TableCell"
const debug = false

export default function FieldAttachmentsTotal_TableCell(props:FieldTableCellProps) {


    let ownValue
    switch (props.listItem.type) {
        case EntityType.TASK:
            ownValue = props.listItem.task.attachmentsTotal
            break

        case EntityType.PROJECT:
        case EntityType.GROUP:
        case EntityType.EVENT:
        default:
            break
    }

    debug && console.log(debug, 'render', props.listItem.debugName, ownValue)

    const showValue = !!ownValue

    return (

        <div className="cell-flex ui5-txt-less-important-small flex-row-center-center" style={getTableCellStyle(props)}>
            {showValue &&
                <>
                    <div className="ui5-ico-13 i5-attachment m-r-5 m-l-1"/>
                    {ownValue}
                </>
            }
        </div>

    )

}



